import { SORT_ORDERS } from '@nicolaudie-group/ng-ui-kit/composables/useDataViewSort'
import dev from '@nicolaudie-group/ng-ui-kit/helpers/dev'

export { SORT_ORDERS }

export const ALL_LIMITS = [5, 10, 20, 50]
export const DEFAULT_LIMIT = 10

export const limitOptions = ALL_LIMITS.map((currentLimit) => ({
  value: currentLimit,
  label: String(currentLimit),
}))

export const DEFAULT_SORTORDER = SORT_ORDERS.DESC

export function getRoute(route = {}, query = {}) {
  return {
    name: route.name,
    path: route.path,
    fullPath: route.fullPath,
    hash: route.hash,
    params: route.params,
    query: {
      ...route.query,
      ...query,
    },
  }
}

/**
 * "Deep" compares (first level only) two objects to verify that the new object
 * is different from the previous one.
 *
 * If they are different, the new object is returned. If they are the same, the
 * previous object is returned.
 */
export function checkChanged(newObject, prevObject) {
  if (Object.compare(newObject, prevObject, { depth: 1 })) {
    dev.info('Object unchanged', prevObject, newObject)
    // If no property was changed, return the previous ref so that
    // watchers/computed are not triggered
    return prevObject
  }
  return newObject
}
